import React, {useCallback} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

import {useRemoveTemplate} from './hooks';

import type {UserSearchTemplate} from 'src/openapi/admin/models/UserSearchTemplate';

type Props = {
    setDefaultTemplate: () => void,
    removedTemplate: UserSearchTemplate | null,
    onClose: () => void,
    onDone: () => void,
    onFail: (error: string) => void,
};

const MODAL_WIDTH = 300;

export const RemoveTemplateModal = (props: Props) => {
    const {onClose, onDone, removedTemplate, setDefaultTemplate, onFail} = props;

    const {busy, event} = useRemoveTemplate({setDefaultTemplate, onSuccess: onDone, onFail});

    const removeTemplate = useCallback(() => {
        if (removedTemplate) {
            event(removedTemplate);
        }
    }, [removedTemplate, event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Remove Layout
            </DialogHeader>
            <DialogMain style={{padding: 24, maxWidth: MODAL_WIDTH}}>
                Are you sure you want to remove this layout?
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button busy={busy} variant="Type.PRIMARY" onClick={removeTemplate}>
                        Remove
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
